import type { PropertySelect } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { propertyBaseSchema } from './propertyBaseSchema'
import { propertyTypeSchema } from './propertyTypeSchema'
import { z } from 'zod'

export const propertySelectSchema = z
  .lazy(() => propertyBaseSchema)
  .and(
    z.object({
      type: z.lazy(() => propertyTypeSchema),
      options: z.array(
        z.object({
          value: z.string(),
          label: z.string(),
          description: z.string().optional(),
        }),
      ),
    }),
  ) as unknown as ToZod<PropertySelect>

export type PropertySelectSchema = PropertySelect